if (!customElements.get("recharge-bundle-one-time-purchase-12ct")) {
  customElements.define(
      "recharge-bundle-one-time-purchase-12ct",
      class rechargeBundleOneTimePurchase12ct extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
          this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
          this.storeIdentifier = this.getAttribute('data-store-identifier');
          this.bundleCollectionId = this.getAttribute('data-bundleCollectionId');
          this.bundleSubProductId = this.getAttribute('data-bundleSubProductId');
          this.oneTimeProductId = this.getAttribute('data-parentProductId');
          this.oneTimeVariantId = this.getAttribute('data-parentVariantId');
        }

        connectedCallback(){
          recharge.init({ storeIdentifier: this.storeIdentifier });
          this.button.addEventListener('click', this.handleSubmit.bind(this));
          const defaultAbsorbencies = this.querySelector('#default_absorbencies[type="application/json"]')
          this.defaultAbsorbencies = JSON.parse(defaultAbsorbencies.textContent);
          const rechargeSubProductVariants = this.querySelector('#child_variants[type="application/json"]')
          this.rechargeSubProductVariants = JSON.parse(rechargeSubProductVariants.textContent);
          console.log(this.defaultAbsorbencies);

          Object.entries(this.defaultAbsorbencies).forEach(([key, value]) => {
            const valueInt = parseInt(value.qty);
            const variant = this.rechargeSubProductVariants.find(v => v.title == key);
            if(valueInt > 1 && !variant.available){
              this.button.classList.add('disabled');
            }
          });

          const mixedVariant = this.rechargeSubProductVariants.find(v => v.title == 'Mixed');
          console.log(mixedVariant)
          if(mixedVariant && !mixedVariant.available){
            Object.entries(this.defaultAbsorbencies).forEach(([key, value]) => {
              const valueInt = parseInt(value.qty);
              if(valueInt%2 == 1) {
                this.button.classList.add('disabled');
              }
            });
          }
        }

        async handleSubmit(e){
          e.preventDefault();
          if(this.button.classList.contains('disabled')) return;

          let bundleParentData = {
            variantId: this.oneTimeVariantId,
            productId:  this.oneTimeProductId,
            sellingPlan: null,
            quantity: 1,
          };

          const absorbencies = {};
          Object.entries(this.defaultAbsorbencies).map(([key, value]) => {
            if(value.qty > 0){
              absorbencies[`${key}`] = value.qty;
            }
          });
          const bundleCollectionId = this.bundleCollectionId
          const bundleSubProductId = this.bundleSubProductId
          const bundleSubProductVariants = this.rechargeSubProductVariants;


          console.log('bundleSubProductVariants', bundleSubProductVariants);
          console.log('absorbencies', absorbencies);
          const findSmallestValue = obj => {
            const smallest = Object.keys(obj).reduce((acc, val) => {
               return Math.min(acc, obj[val]);
            }, Infinity);
            return smallest;
          }
          const smallestAbsorbency = findSmallestValue(absorbencies);
          const remapAbsorbencies = {};
          Object.entries(absorbencies).forEach(([key, value]) => {
            const valueInt = parseInt(value);
            if(valueInt > smallestAbsorbency) {
              const rest = valueInt - smallestAbsorbency;
              remapAbsorbencies[`${key}`] = Math.floor(rest/2);
            }
          });
          remapAbsorbencies[`Mixed`] = smallestAbsorbency;
          console.log('remapAbsorbencies', remapAbsorbencies);

          const selections = [];
          Object.entries(remapAbsorbencies).forEach(([key, value]) => {
            if(value > 0) {
              const data = {};
              data.collectionId = bundleCollectionId;
              data.externalProductId = bundleSubProductId;
              data.quantity = parseInt(value);
              data.externalVariantId = bundleSubProductVariants.find(v => v.title == key).id;
              selections.push(data);
            }
          });

          const properties = {};
          Object.entries(absorbencies).forEach(([key, value]) => {
            if(value > 0) {
              switch(key){
                case 'Regular':
                  properties['Regular'] = parseInt(value)*6;
                  break;
                case 'Heavy':
                  properties['Heavy'] = parseInt(value)*6;
                  break;
              }
            }
          });

          const bundle = {
            "externalVariantId": bundleParentData.variantId,
            "externalProductId": bundleParentData.productId,
            "selections": selections
          };

          console.log('bundle', bundle);
          const rbId = await recharge.bundle.getBundleId(bundle);

          // Adds the value directly to the cart
          properties['_rb_id'] = rbId;
          properties['referenced_product_handle'] = this.referencedProductHandle;
          const cartData = {
            items: [{
              id: bundleParentData.variantId,
              quantity: bundleParentData.quantity,
              properties: properties,
              selling_plan: bundleParentData.sellingPlan
            }]
          };

          console.log(cartData);
          const result = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData),
          });
        }
      }
  );
}

if (!customElements.get("recharge-bundle-one-time-purchase-16ct")) {
  customElements.define(
      "recharge-bundle-one-time-purchase-16ct",
      class rechargeBundleOneTimePurchase16ct extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
          this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
          this.storeIdentifier = this.getAttribute('data-store-identifier');
          this.bundleCollectionId = this.getAttribute('data-bundleCollectionId');
          this.bundleSubProductId = this.getAttribute('data-bundleSubProductId');
          this.oneTimeProductId = this.getAttribute('data-parentProductId');
          this.oneTimeVariantId = this.getAttribute('data-parentVariantId');
        }

        connectedCallback(){
          recharge.init({ storeIdentifier: this.storeIdentifier });
          this.button.addEventListener('click', this.handleSubmit.bind(this));
          const defaultAbsorbencies = this.querySelector('#default_absorbencies[type="application/json"]')
          this.defaultAbsorbencies = JSON.parse(defaultAbsorbencies.textContent);
          const rechargeSubProductVariants = this.querySelector('#child_variants[type="application/json"]')
          this.rechargeSubProductVariants = JSON.parse(rechargeSubProductVariants.textContent);

          Object.entries(this.defaultAbsorbencies).forEach(([key, value]) => {
            const valueInt = parseInt(value.qty);
            const variant = this.rechargeSubProductVariants.find(v => v.title == key);
            if(valueInt > 0 && !variant.available){
              this.button.classList.add('disabled');
            }
          });
        }

        async handleSubmit(e){
          e.preventDefault();
          if(this.button.classList.contains('disabled')) return;

          let bundleParentData = {
            variantId: this.oneTimeVariantId,
            productId:  this.oneTimeProductId,
            sellingPlan: null,
            quantity: 1,
          };

          const absorbencies = {};
          Object.entries(this.defaultAbsorbencies).map(([key, value]) => {
            if(value.qty > 0){
              absorbencies[`${key}`] = value.qty;
            }
          });
          const bundleCollectionId = this.bundleCollectionId
          const bundleSubProductId = this.bundleSubProductId
          const bundleSubProductVariants = this.rechargeSubProductVariants;
          const selections = [];
          const properties = {};
          Object.entries(absorbencies).forEach(([key, value]) => {
            if (value > 0) {
                const data = {};
                data.collectionId = bundleCollectionId;
                data.externalProductId = bundleSubProductId;
                data.quantity = parseInt(value);
                data.externalVariantId = bundleSubProductVariants.find(v => v.title == key).id;
                switch (key) {
                    case 'Light':
                        properties['Light'] = parseInt(value) * 8;
                        break;
                    case 'Regular':
                        properties['Regular'] = parseInt(value) * 8;
                        break;
                    case 'Super':
                        properties['Super'] = parseInt(value) * 8;
                        break;
                    case 'Super+':
                        properties['Super+'] = parseInt(value) * 8;
                        break;
                }
                selections.push(data);
            }
        });


          const bundle = {
            "externalVariantId": bundleParentData.variantId,
            "externalProductId": bundleParentData.productId,
            "selections": selections
          };

          console.log('bundle', bundle);
          const rbId = await recharge.bundle.getBundleId(bundle);

          // Adds the value directly to the cart
          properties['_rb_id'] = rbId;
          properties['referenced_product_handle'] = this.referencedProductHandle;
          const cartData = {
            items: [{
              id: bundleParentData.variantId,
              quantity: bundleParentData.quantity,
              properties: properties,
              selling_plan: bundleParentData.sellingPlan
            }]
          };

          const result = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData),
          });
        }
      }
  );
}


if (!customElements.get("recharge-bundle-one-time-purchase")) {
  customElements.define(
      "recharge-bundle-one-time-purchase",
      class rechargeBundleOneTimePurchase extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
          this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
          this.storeIdentifier = this.getAttribute('data-store-identifier');
          this.bundleCollectionId = this.getAttribute('data-bundleCollectionId');
          this.bundleSubProductId = this.getAttribute('data-bundleSubProductId');
          this.oneTimeProductId = this.getAttribute('data-parentProductId');
          this.oneTimeVariantId = this.getAttribute('data-parentVariantId');
        }

        connectedCallback(){
          recharge.init({ storeIdentifier: this.storeIdentifier });
          this.button.addEventListener('click', this.handleSubmit.bind(this));
          const rechargeSubProductVariants = this.querySelector('#child_variants[type="application/json"]');
          this.rechargeSubProductVariants = JSON.parse(rechargeSubProductVariants.textContent);
          this.rechargeSubProductVaraint = this.rechargeSubProductVariants.find(v => v.available);
          if(!this.rechargeSubProductVaraint){
            this.button.classList.add('disabled');
          }
        }

        async handleSubmit(e){
          e.preventDefault();
          if(this.button.classList.contains('disabled')) return;

          let bundleParentData = {
            variantId: this.oneTimeVariantId,
            productId:  this.oneTimeProductId,
            sellingPlan: null,
            quantity: 1,
          };

          const bundleCollectionId = this.bundleCollectionId;
          const bundleSubProductId = this.bundleSubProductId;

          const selections = [];
          const properties = {};

          const data = {};
          data.collectionId = bundleCollectionId;
          data.externalProductId = bundleSubProductId;
          data.quantity =  1;
          data.externalVariantId = this.rechargeSubProductVaraint.id;

          selections.push(data);

          const bundle = {
            "externalVariantId": bundleParentData.variantId,
            "externalProductId": bundleParentData.productId,
            "selections": selections
          };

          console.log('bundle', bundle);
          const rbId = await recharge.bundle.getBundleId(bundle);

          // Adds the value directly to the cart
          properties['_rb_id'] = rbId;
          properties['referenced_product_handle'] = this.referencedProductHandle;
          if(this.rechargeSubProductVariants.length > 1){
            //properties['size'] = this.rechargeSubProductVaraint.title;
          }

          const cartData = {
            items: [{
              id: bundleParentData.variantId,
              quantity: bundleParentData.quantity,
              properties: properties,
              selling_plan: bundleParentData.sellingPlan
            }]
          };

          const result = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData),
          });
        }
      }
  );
}
